import type { DeviceInformationResourceReadApi } from '@ingenico/api-sdk-resource-private';
import type { PhysicalDeviceInformation } from '../../models/physicalDeviceInformation.model';

function mapAuthenticationData(response: DeviceInformationResourceReadApi) {
  return {
    authenticationMethods: response.authenticationMethods || [],
    authenticationUiType: response.authenticationUiType || 'LIMITED',
  };
}

function mapDeviceBasicInfo(response: DeviceInformationResourceReadApi) {
  return {
    deviceBrand: response.deviceBrand || '',
    deviceImage: response.deviceImage || '',
    deviceModel: response.deviceModel || '',
    deviceType: response.deviceType || '',
  };
}

function mapDeviceConfiguration(response: DeviceInformationResourceReadApi) {
  return {
    installedClientApplicationTypes: response.installedClientApplicationTypes || [],
    operationMode: response.operationMode || 'SUPERVISED',
    securityLevel: response.securityLevel || 'CONFIDENTIAL',
    supportedTwoFaTypes: response.supportedTwoFaTypes || [],
  };
}

function mapDeviceIdentifiers(response: DeviceInformationResourceReadApi, physicalDeviceId: string) {
  return {
    physicalDeviceId: response.physicalDeviceId || physicalDeviceId,
    serialNumber: response.serialNumber || '',
  };
}

export function mapPhysicalDeviceInformationResponse(
  response: DeviceInformationResourceReadApi,
  physicalDeviceId: string,
): PhysicalDeviceInformation {
  return {
    ...mapAuthenticationData(response),
    ...mapDeviceBasicInfo(response),
    ...mapDeviceConfiguration(response),
    ...mapDeviceIdentifiers(response, physicalDeviceId),
  };
}
